import FormWizard2Container from "./Form";

export default function PublicLayout() {
    return (
        <>
        <FormWizard2Container/>
        </>
    )
}